import { render } from "./FilaContact.vue?vue&type=template&id=ab5e1b44&scoped=true"
import script from "./FilaContact.vue?vue&type=script&lang=js"
export * from "./FilaContact.vue?vue&type=script&lang=js"

import "./FilaContact.vue?vue&type=style&index=0&id=ab5e1b44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5e1b44"]])

export default __exports__